/**
 * Created by ruslan on 05.06.17.
 */
import React, { Component } from 'react'

export default class Home extends Component {

    render() {
        return (
            <div >
home

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/react-material-components-demo/pages/Home.js